/* unplugin-vue-components disabled */import { ElDivider as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import { ElForm as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElPopover as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/popover/style/css';
import { ElIcon as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_4 from '~icons/ep/warning-filled';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/img1111.jpg';
import _imports_1 from '@/assets/icons/wechat.png';
import _imports_2 from '@/assets/icons/qq.png';
import _imports_3 from '@/assets/icons/icon-apple.png';
const _withScopeId = n => (_pushScopeId("data-v-51e9e4e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  id: "card-title-theme",
  class: "card-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SDK皮肤", -1));
const _hoisted_3 = {
  key: 1,
  class: "box"
};
const _hoisted_4 = {
  class: "left marginR50"
};
const _hoisted_5 = {
  class: "marginR20"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*请上传大小不超过尺寸：500X125PNG图片", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "浮标配置开启后，玩家可以在游戏内点击logo打开浮标，执行切换账号等操作", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0,
  style: {
    "max-width": "100%"
  }
}, null, -1));
const _hoisted_10 = {
  class: "el-form-item__label",
  style: {
    "display": "inline-flex",
    "align-items": "center"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_12 = {
  class: "marginR20"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*请上传大小不超过尺寸：150*150PNG图片", -1));
const _hoisted_15 = {
  class: "right"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "预览：", -1));
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "input-wrapper"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_1
}), /*#__PURE__*/_createElementVNode("p", null, "微信登录")], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_2
}), /*#__PURE__*/_createElementVNode("p", null, "QQ登录")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_3
}), /*#__PURE__*/_createElementVNode("p", null, "Apple")], -1));
const _hoisted_23 = [_hoisted_20, _hoisted_21, _hoisted_22];
import logo1 from '@/assets/icons/logo.png';
import phoneBlack from '@/assets/icons/phone-black.png';
import phone from '@/assets/icons/phone-pink.png';
import { apiUsdkSwitchConfGameTheme, apiUsdkSwitchConfSaveGlobalTheme, apiUsdkSwitchConfSaveInternalTheme } from '@/api/usdk';
import { UseComProps } from './hooks';
import { UseGlobalConfig } from '@/utils/hooks';
import CustomParams from './customParams.vue';
import SaveBtn from './saveBtn.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'theme',
  props: {
    ...UseComProps()
  },
  setup(__props) {
    const props = __props;
    const isEdit = ref(false);
    const options = [{
      label: process.env.VUE_APP_SDK_NAME + '粉',
      value: 'heroPur'
    }, {
      label: '通用黑',
      value: 'black'
    }, {
      label: '通用白',
      value: 'white'
    }];
    const form = ref({
      theme: 'heroPur',
      icon2: [],
      icon1: [],
      cids: []
    });
    const icon2 = ref('');
    const icon1 = ref('');
    const configs = ref();
    const saving = ref(false);
    const isShow = ref(true);
    const getTheme = () => {
      apiUsdkSwitchConfGameTheme({
        gid: props.gid,
        cid: props.channel && props.channel.cid
      }).then(res => {
        console.log('configs', res);
        if (res.code === 0) {
          configs.value = res.data;
          console.log('configs', configs.value);
          if (res.data.length !== 0) {
            const params = {};
            res.data.forEach(item => {
              if (item.var === 'asset.ui.logo1') {
                params.icon1 = item.val ? [{
                  url: item.val
                }] : [];
              }
              if (item.var === 'asset.ui.logo2') {
                params.icon2 = item.val ? [{
                  url: item.val
                }] : [];
              }
              if (item.var === 'asset.ui.theme') {
                params.theme = item.val;
              }
            });
            form.value = JSON.parse(JSON.stringify(params));
          } else {
            ElMessage.warning('暂无可用主题!');
          }
        } else if (res.code === -1) {
          isShow.value = false;
        }
      });
    };
    const handleDeleteImg = () => {
      form.value.icon1 = [];
    };
    const handleDeleteImg2 = () => {
      form.value.icon2 = [];
    };
    const handleClick = type => {
      if (type === 'edit') {
        isEdit.value = true;
      } else if (type === 'cancel') {
        isEdit.value = false;
      } else {
        handleSave();
      }
    };
    const handleSave = () => {
      var _props$channel;
      let params = JSON.parse(JSON.stringify(form.value));
      console.log('parmas', params);
      if ([$channel.OFFICIAL_CHANNEL, $channel.OFFICIAL_IOS_CHANNEL].includes((_props$channel = props.channel) === null || _props$channel === void 0 ? void 0 : _props$channel.channel) && params.icon1 && params.icon1.length === 0) {
        ElMessage.warning('请上传浮标icon');
        return;
      }
      // if (params.icon2.length === 0) {
      // 	ElMessage.warning('请上传Logo');
      // 	return;
      // }
      saving.value = true;
      const data = configs.value;
      data.forEach(item => {
        if (item.var === 'asset.ui.logo1') {
          item.val = Array.isArray(params.icon1) ? params.icon1[0].url : params.icon1;
        }
        if (item.var === 'asset.ui.logo2') {
          console.log(params.icon2);
          if (params.icon2.length === 0) {
            item.val = '';
          } else {
            item.val = Array.isArray(params.icon2) ? params.icon2[0].url : params.icon2;
          }
        }
        if (item.var === 'asset.ui.theme') {
          item.val = params.theme;
        }
      });
      const api = props.channel && props.channel.channel.includes('global') ? apiUsdkSwitchConfSaveGlobalTheme : apiUsdkSwitchConfSaveInternalTheme;
      api({
        data: JSON.stringify(data)
      }).then(res => {
        if (res.code === 0) {
          form.value = {
            theme: 'heroPur',
            icon2: [],
            icon1: [],
            cids: []
          };
          getTheme();
          isEdit.value = false;
        }
        saving.value = false;
      });
    };
    watch(() => form.value, val => {
      var _val$icon;
      if (val.icon2.length > 0) {
        icon2.value = val.icon2[0].url;
      } else {
        icon2.value = '';
      }
      if ((val === null || val === void 0 ? void 0 : (_val$icon = val.icon1) === null || _val$icon === void 0 ? void 0 : _val$icon.length) > 0) {
        icon1.value = val.icon1[0].url;
      } else {
        icon1.value = '';
      }
    }, {
      deep: true
    });
    const {
      $channel
    } = UseGlobalConfig();
    onMounted(() => {
      var _props$channel2;
      getTheme();
      const dom = document.querySelector('#card-title-theme');
      if (!dom) {
        return;
      }
      const isShow = props.channel.plat === 0;
      const isShowSplash = !((_props$channel2 = props.channel) !== null && _props$channel2 !== void 0 && _props$channel2.channel.includes($channel.OFFICIAL_IOS_CHANNEL));
      if (isShow && isShowSplash) {
        dom.style.top = '300px';
      } else if (isShow && !isShowSplash) {
        dom.style.top = '240px';
      } else if (!isShow && isShowSplash) {
        dom.style.top = '240px';
      } else {
        dom.style.top = '178px';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_i_ep_WarningFilled = __unplugin_components_4;
      const _component_el_icon = __unplugin_components_5;
      const _component_el_popover = __unplugin_components_6;
      const _component_el_form = __unplugin_components_7;
      const _component_el_divider = __unplugin_components_8;
      return _openBlock(), _createElementBlock(_Fragment, null, [[_unref($channel).OFFICIAL_CHANNEL, _unref($channel).OFFICIAL_IOS_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes(_ctx.channel.channel) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, !_unref(isEdit) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: _unref(saving),
        onCancel: handleClick,
        onSave: handleClick
      }, null, 8, ["loading"]))])) : _createCommentVNode("", true), [_unref($channel).OFFICIAL_CHANNEL, _unref($channel).OFFICIAL_IOS_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes(_ctx.channel.channel) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => {
          var _ctx$channel;
          return [![_unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes(_ctx.channel.channel) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "主题"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(form).theme,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).theme = $event),
              disabled: !_unref(isEdit),
              "default-first-option": ""
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "Logo"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              src: _unref(icon2),
              alt: "",
              style: {
                "width": "250px",
                "display": "block"
              }
            }, null, 8, _hoisted_6), _withDirectives(_createVNode(_component_el_button, {
              disabled: !_unref(isEdit),
              class: "marginT10",
              type: "danger",
              onClick: handleDeleteImg2
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 1
            }, 8, ["disabled"]), [[_vShow, _unref(icon2)]])]), _createVNode(_component_u_upload, {
              modelValue: _unref(form).icon2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).icon2 = $event),
              disabled: !_unref(isEdit),
              imgWH: [500, 125],
              limit: 1,
              showFileList: false,
              accept: ".png",
              listType: "picture"
            }, {
              tip: _withCtx(() => [_hoisted_7]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), ![_unref($channel).GLOBAL_OFFICIAL_CHANNEL, _unref($channel).GLOBAL_OFFICIAL_IOS_CHANNEL].includes((_ctx$channel = _ctx.channel) === null || _ctx$channel === void 0 ? void 0 : _ctx$channel.channel) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
              width: 400,
              placement: "top-start",
              title: "浮标说明",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [_createElementVNode("label", _hoisted_10, [_createTextVNode(" 浮标Logo "), _createVNode(_component_el_icon, {
                color: "#e6a23c"
              }, {
                default: _withCtx(() => [_createVNode(_component_i_ep_WarningFilled)]),
                _: 1
              })])]),
              default: _withCtx(() => [_hoisted_8, _hoisted_9]),
              _: 1
            })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
              src: _unref(icon1),
              alt: "",
              style: {
                "width": "250px",
                "display": "block"
              }
            }, null, 8, _hoisted_13), _withDirectives(_createVNode(_component_el_button, {
              disabled: !_unref(isEdit),
              class: "marginT10",
              type: "danger",
              onClick: handleDeleteImg
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 1
            }, 8, ["disabled"]), [[_vShow, _unref(icon1)]])]), _createVNode(_component_u_upload, {
              modelValue: _unref(form).icon1,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).icon1 = $event),
              disabled: !_unref(isEdit),
              imgWH: [150, 150],
              limit: 1,
              showFileList: false,
              accept: ".png",
              listType: "picture"
            }, {
              tip: _withCtx(() => [_hoisted_14]),
              _: 1
            }, 8, ["modelValue", "disabled"])])])]),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", {
        class: _normalizeClass(['login-box', 'marginT10', _unref(form).theme == 'black' ? 'black' : _unref(form).theme == 'white' ? 'white' : ''])
      }, [_createElementVNode("img", {
        src: _unref(icon2) || _unref(logo1),
        alt: "",
        class: "logo-img"
      }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [_createElementVNode("input", {
        class: _normalizeClass(['input', _unref(form).theme == 'white' ? 'input-border' : '']),
        placeholder: "请输入账号",
        type: "text"
      }, null, 2), _createElementVNode("img", {
        src: _unref(form).theme == 'white' ? _unref(phoneBlack) : _unref(phone),
        alt: "",
        class: "input-icon"
      }, null, 8, _hoisted_19)]), _createElementVNode("div", {
        class: _normalizeClass(['btn', 'marginT20', _unref(form).theme == 'white' ? 'black' : ''])
      }, "下一步", 2), _createVNode(_component_el_divider, null, {
        default: _withCtx(() => [_createElementVNode("span", {
          style: _normalizeStyle({
            fontSize: '12px',
            color: _unref(form).theme == 'black' ? '#fff' : 'gray'
          })
        }, "其他登录方式", 4)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(['icons-box', _unref(form).theme == 'black' ? 'white' : ''])
      }, _hoisted_23, 2)], 2)])])) : _createCommentVNode("", true), _createVNode(CustomParams, {
        channel: _ctx.channel,
        gid: _ctx.gid,
        class: "marginT10"
      }, null, 8, ["channel", "gid"])], 64);
    };
  }
});